export const colors = {
    midnightBlue: {
        100: {
            hex: '#B8BDD9',
            rgb: '184, 189, 217',
            cmyk: '15, 13, 0, 15'
        },
        200: {
            hex: '#727AB2',
            rgb: '114, 122, 178',
            cmyk: '36, 31, 0, 30'
        },
        400: {
            hex: '#404877',
            rgb: '64, 72, 119',
            cmyk: '46, 39, 0, 53'
        },
        600: {
            hex: '#292E42',
            rgb: '41, 46, 66',
            cmyk: '38, 30, 0, 74'
        },
        900: {
            hex: '#1A1D31',
            rgb: '26, 29, 49',
            cmyk: '87, 80, 51, 63'
        }
    },
    goodwayBlue: {
        50: {
            hex: '#ECF4F9',
            rgb: '236, 244, 249',
            cmyk: '5, 2, 0, 2'
        },
        200: {
            hex: '#81BFDC',
            rgb: '129, 191, 220',
            cmyk: '41, 13, 0, 14'
        },
        400: {
            hex: '#007DC6',
            rgb: '0, 125, 198',
            cmyk: '84, 44, 0, 0'
        },
        600: {
            hex: '#0B3446',
            rgb: '11, 52, 70',
            cmyk: '84, 26, 000, 073'
        }
    },
    sun: {
        50: {
            hex: '#FDFBED',
            rgb: '253, 251, 237',
            cmyk: '0, 1, 6, 1'
        },
        100: {
            hex: '#FFF7E4',
            rgb: '255, 247, 228',
            cmyk: '0, 3, 11, 0',
        },
        200: {
            hex: '#FFE623',
            rgb: '255, 230, 35',
            cmyk: '0, 20, 86, 0'
        },
        400: {
            hex: '#FCD119',
            rgb: '252, 209, 25',
            cmyk: '2, 16, 96, 0'
        },
        600: {
            hex: '#FBAD19',
            rgb: '251, 173, 25',
            cmyk: '0, 31, 90, 2'
        },
        800: {
            hex: '#FFB815',
            rgb: '255, 184, 18',
            cmyk: '0, 28, 93, 0'
        }
    },
    sand: {
        100: {
            hex: '#F1F1F1',
            rgb: '241, 241, 241',
            cmyk: '4, 3, 3, 0'
        },
        200: {
            hex: '#C1C1C1',
            rgb: '193, 193, 193',
            cmyk: '4, 3, 3, 24'
        },
        300: {
            hex: '#A9A9A9',
            rgb: '169, 169, 169',
            cmyk: '4, 3, 3, 34'
        },
        400: {
            hex: '#919191',
            rgb: '145, 145, 145',
            cmyk: '4, 3, 3, 43'
        },
        500: {
            hex: '#797979',
            rgb: '121, 121, 121',
            cmyk: '4, 3, 3, 53'
        },
        600: {
            hex: '#606060',
            rgb: '96, 96, 96',
            cmyk: '4, 3, 3, 62'
        },
        700: {
            hex: '#484848',
            rgb: '72, 72, 72',
            cmyk: '4, 3, 3, 72'
        }
    },
    red: {
        50: {
            hex: '#F9EDEC',
            rgb: '249, 237, 236',
            cmyk: '0, 5, 5, 2'
        },
        400: {
            hex: '#C81420',
            rgb: '200, 20, 32',
            cmyk: '0, 71, 66, 21'
        },
        600: {
            hex: '#5E040A',
            rgb: '94, 4, 10',
            cmyk: '0, 35, 33, 63'
        }
    },
    green: {
        50: {
            hex: '#EDFCE7',
            rgb: '237, 252, 231',
            cmyk: '6, 0, 8, 1'
        },
        400: {
            hex: '#5FAD41',
            rgb: '95, 173, 65',
            cmyk: '45, 0, 63, 32'
        },
        600: {
            hex: '#22550F',
            rgb: '34, 85, 15',
            cmyk: '20, 0, 27, 67'
        }
    },
    black: {
        hex: '#000000',
        rgb: '0, 0, 0',
        cmyk: '0, 0, 0, 100'
    },
    white: {
        hex: '#FFFFFF',
        rgb: '255, 255, 255',
        cmyk: '0, 0, 0, 0'
    }
};

export const lightAlertColors = {
    default: {
        textColor: `rgba(${colors.black.rgb}, .8)`,
        backgroundColor: colors.sand[100].hex,
        iconColor: colors.sand[400].hex,
        buttonHoverColor: colors.sand[600].hex
    },
    error: {
        textColor: `rgba(${colors.black.rgb}, .8)`,
        backgroundColor: colors.red[50].hex,
        iconColor: colors.red[400].hex,
        buttonHoverColor: colors.red[600].hex
    },
    warning: {
        textColor: `rgba(${colors.black.rgb}, .8)`,
        backgroundColor: colors.sun[100].hex,
        iconColor: colors.sun[600].hex,
        buttonHoverColor: colors.sun[800].hex
    },
    info: {
        textColor: `rgba(${colors.black.rgb}, .8)`,
        backgroundColor: colors.sun[50].hex,
        iconColor: colors.sun[400].hex,
        buttonHoverColor: colors.sun[600].hex,
    },
    success: {
        textColor: `rgba(${colors.black.rgb}, .8)`,
        backgroundColor: colors.goodwayBlue[50].hex,
        iconColor: colors.goodwayBlue[400].hex,
        buttonHoverColor: colors.goodwayBlue[600].hex,
    },
};

export const darkAlertColors = {
    default: {
        textColor: `rgba(${colors.white.rgb}, .8)`,
        backgroundColor: colors.sand[400].hex,
        iconColor: `rgba(${colors.white.rgb}, 0.75)`,
        buttonHoverColor: colors.sand[100].hex,
    },
    error: {
        textColor: `rgba(${colors.white.rgb}, .8)`,
        backgroundColor: colors.white.hex,
        iconColor: `rgba(${colors.white.rgb}, 0.75)`,
        buttonHoverColor: colors.red[400].hex,
    },
    warning: {
        textColor: `rgba(${colors.white.rgb}, .8)`,
        backgroundColor: colors.sun[600].hex,
        iconColor: `rgba(${colors.white.rgb}, 0.75)`,
        buttonHoverColor: colors.sun[100].hex,
    },
    info: {
        textColor: `rgba(${colors.white.rgb}, .8)`,
        backgroundColor: colors.sun[400].hex,
        iconColor: `rgba(${colors.white.rgb}, 0.75)`,
        buttonHoverColor: colors.sun[600].hex,
    },
    success: {
        textColor: `rgba(${colors.white.rgb}, .8)`,
        backgroundColor: colors.goodwayBlue[400].hex,
        iconColor: `rgba(${colors.white.rgb}, 0.75)`,
        buttonHoverColor: colors.goodwayBlue[50].hex,
    },
};



// WEBPACK FOOTER //
// ./src/services/theme/brandTheme/brandColors.js